import './Rules.css'

export default function Rules() {
  return (
    <div className="rules-container">
      <div className="rules-header">
        <div className="rules-logo">
          <img
            src="/images/logo/finallogosquare.png"
            alt="RiftChess"
            className="logo-icon"
          />
        </div>
        <h1>Rules</h1>
        <p>Learn how to master dimensional chess</p>
      </div>

      <div className="rules-content">
        <section className="rules-section">
          <h2>What is RiftChess?</h2>

          <h3>Dimensional Chess Evolution</h3>
          <p>RiftChess extends traditional chess with special colored squares that provide unique abilities, creating a dynamic battlefield where strategy meets chaos. Master the timing and effects of these dimensional rifts to dominate your opponents!</p>

          <h3>Move Counting System</h3>
          <ul>
            <li><strong>Move 1:</strong> White's first turn</li>
            <li><strong>Move 2:</strong> Black's first turn</li>
            <li><strong>Move 3:</strong> White's second turn (first special squares appear)</li>
            <li>And so on, alternating between players...</li>
          </ul>
        </section>

        <section className="rules-section death-section">
          <h2>🟥 Red Squares (Death Squares)</h2>

          <h3>Appearance Schedule</h3>
          <p>Red squares appear <strong>every 3 moves</strong> (moves 3, 6, 9, 12, etc.) at the beginning of the turn.</p>

          <h3>Scaling System</h3>
          <ul>
            <li><strong>Moves 1-14:</strong> 1 red square appears</li>
            <li><strong>After move 15:</strong> 2 red squares appear</li>
            <li><strong>After move 33:</strong> 3 red squares appear</li>
          </ul>

          <h3>Death Mechanism</h3>
          <p><strong>Critical:</strong> Any piece on a red square at the <strong>END</strong> of the turn dies. Red squares appear at the beginning of the turn when they are scheduled. If it's your turn when a red square spawns under your piece, you can save it by moving the piece away. If it's not your turn, you cannot save it.</p>

          <h3>Restrictions</h3>
          <ul>
            <li>Cannot appear on ranks 1 and 8 during the first 10 moves</li>
            <li>Cannot appear under the king (king protection)</li>
            <li>Pieces cannot be teleported onto red squares</li>
          </ul>
        </section>

        <section className="rules-section teleport-section">
          <h2>🟦 Blue Squares (Teleport Squares)</h2>

          <h3>Appearance Schedule</h3>
          <p>Blue squares appear <strong>every 7 moves</strong> in consecutive pairs:</p>
          <ul>
            <li><strong>Moves 7-8:</strong> First pair (both players get one)</li>
            <li><strong>Moves 14-15:</strong> Second pair</li>
            <li><strong>Moves 21-22:</strong> Third pair, and so on...</li>
          </ul>

          <h3>Teleportation Effect</h3>
          <p>Any piece that ends its move on a blue square can be <strong>teleported to any empty square</strong> of your choice on the board.</p>

          <h3>Safety Restrictions</h3>
          <ul>
            <li>Cannot teleport onto red squares</li>
            <li>Cannot teleport onto green squares</li>
          </ul>
        </section>

        <section className="rules-section promotion-section">
          <h2>🟩 Green Squares (Promotion Squares)</h2>

          <h3>Appearance Schedule</h3>
          <p>Green squares appear <strong>every 10 moves</strong> in consecutive pairs:</p>
          <ul>
            <li><strong>Moves 10-11:</strong> First pair</li>
            <li><strong>Moves 20-21:</strong> Second pair</li>
            <li><strong>Moves 30-31:</strong> Third pair, and so on...</li>
          </ul>

          <h3>Promotion Effects</h3>
          <p>Pieces that end their move on a green square are promoted:</p>
          <ul>
            <li><strong>Pawn →</strong> Knight or Bishop (player chooses)</li>
            <li><strong>Knight or Bishop →</strong> Rook</li>
            <li><strong>Rook →</strong> Queen</li>
          </ul>

          <h3>Restrictions</h3>
          <p>Pieces cannot be teleported onto green squares (must move there intentionally).</p>
        </section>

        <section className="rules-section">
          <h2>Visual Effects</h2>

          <h3>Death Effects (Red Squares)</h3>
          <p>When a piece dies, it appears as a "ghost" with low opacity and dashed border for the following turn.</p>

          <h3>Teleportation Effects (Blue Squares)</h3>
          <ul>
            <li><strong>Departure square:</strong> Dashed blue border where piece left from</li>
            <li><strong>Destination square:</strong> Solid blue border where piece arrived</li>
            <li>Both effects last for 1 turn</li>
          </ul>

          <h3>Promotion Effects (Green Squares)</h3>
          <p>Promoted pieces show a green dashed border for 1 turn after transformation.</p>
        </section>

        <section className="rules-section">
          <h2>Important Rules</h2>

          <h3>Square Overlap</h3>
          <p><strong>Critical:</strong> Special squares cannot overlap - each square can only have one type of special effect.</p>

          <h3>Timing</h3>
          <p>Special squares appear at the <strong>beginning</strong> of turns based on move count. Multiple types can appear on the same turn if the numbers align.</p>
        </section>

        <section className="rules-section">
          <h2>Strategy Tips</h2>

          <h3>Count the Moves</h3>
          <p>Always keep track of the move count to anticipate when special squares will appear. Plan your piece positions accordingly.</p>

          <h3>Use Special Squares Tactically</h3>
          <ul>
            <li>Force opponent pieces onto red squares</li>
            <li>Use blue squares for surprise attacks or escapes</li>
            <li>Time your moves to benefit from green square promotions</li>
          </ul>
        </section>
      </div>
    </div>
  )
}